export default class ArchiveAttachmentTypes {
  static TAX_STATEMENT = "taxStatement";

  static AGREEMENT = "agreement";

  static BANK_STATEMENT = "bankStatement";

  static FOLDER = "folder";

  static OTHER = "other";
}
